import { useSelector } from "react-redux";
import StudentPerformanceDashboard from "../../StudentPerformanceDashboard/newDesign"
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";

const UserReportsByUserID = () => {
  const location = useLocation()
  const {  } = useSelector((state) => state.studentPerformenceConstruct);

  if (!location?.state?.activeConstruct) {
    return (
      <div className="flex justify-center items-center h-full">
        <p className="text-center text-gray-500 font-black text-3xl">Select a construct to view details</p>
      </div>
    )

  }
  return (
    <div className="-mt-16">
      <StudentPerformanceDashboard
        isHeaderManu
        isReporting
      />
    </div>
  )


}

export default UserReportsByUserID